import type { ListItemWire, ListMemberWire, ListWire } from '../schemas/list';
import type { List, ListItem, ListMember } from '@/features/lists/types';

/**
 * Mapping functions to convert wire format (backend snake_case)
 * to domain format (app camelCase) for list entities
 */

/**
 * Convert wire list format to domain list format
 */
export function mapListWireToDomain(wire: ListWire): List {
  return {
    id: wire.id,
    ownerId: wire.owner_id,
    name: wire.name,
    description: wire.description,
    type: wire.type,
    visibility: wire.visibility,
    coverImageUrl: wire.cover_image_url,
    itemCount: wire.item_count,
    memberCount: wire.member_count,
    ownerName: wire.owner_name,
    createdAt: wire.created_at,
    updatedAt: wire.updated_at,
    pendingMembership: wire.pending_membership
      ? mapListMemberWireToDomain(wire.pending_membership)
      : undefined,
  };
}

/**
 * Convert wire list item format to domain list item format
 */
export function mapListItemWireToDomain(wire: ListItemWire): ListItem {
  return {
    id: wire.id,
    listId: wire.list_id,
    itemType: wire.item_type,
    itemId: wire.item_id,
    note: wire.note,
    addedBy: wire.added_by,
    addedByName: wire.added_by_name,
    businessName: wire.business_name,
    menuItemName: wire.menu_item_name,
    coverPhotoUrl: wire.cover_photo_url,
    createdAt: wire.created_at,
  };
}

/**
 * Convert wire list member format to domain list member format
 */
export function mapListMemberWireToDomain(wire: ListMemberWire): ListMember {
  return {
    id: wire.id,
    listId: wire.list_id,
    userId: wire.user_id,
    role: wire.role,
    status: wire.status,
    invitedBy: wire.invited_by,
    userName: wire.user_name,
    userUsername: wire.user_username,
    userImage: wire.user_image,
    createdAt: wire.created_at,
    updatedAt: wire.updated_at,
  };
}
